"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWalletEndpoints = createWalletEndpoints;
/**
 * Kartvizit cüzdanı (Epic 18/19).
 */
function createWalletEndpoints(client) {
    return {
        /**
         * CÜZDAN (Epic 18/19 — Akış D/E).
         *
         * KAPSAM: hiçbir uç "kullanıcı kimliği" ALMAZ; her çağrı oturumdaki kişinin
         * KENDİ cüzdanıdır (KÇ 4 + IDOR). Başkasının kaydını istemenin tek yolu
         * kayıt kimliğini tahmin etmektir ve sunucu ona 404 döner.
         *
         * Sorgu parametreleri ELLE tiplenir: Joi şeması OpenAPI'ye çıkmıyor (proje
         * kararı — doğrulama Joi ile), o yüzden istemci tipi sözleşmenin yanında
         * `packages/shared/contracts/wallet.ts` ile ELLE senkron tutulur.
         */
        wallet: {
            /*
             * `as never` BURADA KALIYOR ve gerekcesi generator'dedir: uretilen
             * `schema.ts` bu yol icin sorgu parametresi BEYAN ETMIYOR (tip `undefined`),
             * yani hicbir sorgu nesnesi atanamaz. Tipi susturan cast degil, EKSIK
             * SEMA sorunudur — sorgunun dogrulugunu `WalletListParams` (sozlesmeden
             * TURETILMIS) saglar. Controller'a `@ApiQuery` beyanlari eklenip
             * `api-client:generate` kosuldugunda bu cast kalkar.
             */
            list: (query = {}) => client.call('/wallet', 'get', { query: mutableWalletQuery(query) }),
            /**
             * "ZATEN TANIŞTIKLARIN" ŞERİDİ — yaklaşan etkinliklerde cüzdanımdan kim
             * var. Sorgu parametresi YOKTUR: kapsam oturumdaki kişidir.
             */
            lanes: () => client.call('/wallet/lanes', 'get', {}),
            get: (encounterId) => client.call('/wallet/{encounterId}', 'get', { path: { encounterId } }),
            update: (encounterId, input) => client.call('/wallet/{encounterId}', 'patch', {
                path: { encounterId },
                /*
                 * TEK FARK `readonly` VARYANSI: OpenAPI ureticisi dizileri mutable
                 * uretir, sozlesme ise `readonly`. Kopya cikarmak `as never`den
                 * iyidir — govde hala URETILEN tiple denetlenir, yani controller'da
                 * alan degisirse burada DERLEME KIRILIR.
                 */
                body: {
                    ...(input.note !== undefined ? { note: input.note } : {}),
                    ...(input.tags !== undefined ? { tags: [...input.tags] } : {}),
                    ...(input.reminder !== undefined
                        ? {
                            reminder: input.reminder === null
                                ? null
                                : { dueAt: input.reminder.dueAt, text: input.reminder.text },
                        }
                        : {}),
                },
            }),
            remove: (encounterId) => client.call('/wallet/{encounterId}', 'delete', { path: { encounterId } }),
            /**
             * DIŞA AKTARIM — yanıt JSON DEĞİL, dosya içeriğidir (CSV/vCard). Tipli
             * `call()` JSON çözer, o yüzden bu tek uç ham `request()` kullanır ve
             * yolu burada TEK yerde yazılıdır.
             */
            exportFile: (query) => client.request('/wallet/export', {
                method: 'get',
                query: mutableWalletQuery(query),
                responseType: 'text',
            }),
        },
    };
}
/**
 * `readonly` dizileri kopyalar. Sozlesme tipleri `readonly`dir (kazayla
 * degistirilemesinler), OpenAPI ureticisi ise mutable dizi uretir; tek fark
 * budur. Kopya cikarmak, tipi `as never` ile susturmaktan iyidir: sorgu alanlari
 * hala TIP DENETIMINDEN gecer.
 */
function mutableWalletQuery(query) {
    return {
        ...query,
        ...(query.eventIds ? { eventIds: [...query.eventIds] } : {}),
        ...(query.sectors ? { sectors: [...query.sectors] } : {}),
    };
}
//# sourceMappingURL=wallet.js.map